"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageManager = void 0;
const uuid_1 = require("./uuid");
class LocalStorageManager {
    constructor(key = uuid_1.UUID_STORAGE, value = uuid_1.UUID) {
        this.key = key;
        this.value = value;
        this.keepOnClear();
        this.keepOnClearByClient();
    }
    /**
     * Interceptor for clean-out triggered by localStorage.clear().
     */
    keepOnClear() {
        const key = this.key;
        const value = this.value;
        const localStorageClear = localStorage.clear;
        const localStorageRemoveItem = localStorage.removeItem;
        const onClear = (fn) => function (...args) {
            const oldValue = localStorage.getItem(key);
            fn.apply(this, args);
            localStorage.setItem(key, oldValue !== null && oldValue !== void 0 ? oldValue : value);
        };
        localStorage.clear = onClear(localStorageClear);
        localStorage.removeItem = onClear(localStorageRemoveItem);
    }
    /**
     * Interceptor for clean-out triggered through browser UI.
     */
    keepOnClearByClient() {
        window.addEventListener('storage', (event) => {
            var _a;
            if (event.key === this.key || event.key === null) {
                localStorage.setItem(this.key, (_a = event.oldValue) !== null && _a !== void 0 ? _a : this.value);
            }
        });
    }
}
exports.LocalStorageManager = LocalStorageManager;
